import React from "react";
import { Link } from "react-router-dom";

const Privacy = () => {
  return (
    <React.Fragment>
      <section className="privacy_banner">
        <div className="wrapper">
          <h1 className="usable_title">Privacy Policy</h1>
          <span className="lastUpdate">
            Last Updated On <b>1st Jan 2024</b>
          </span>
          <p className="para_common">
            Your privacy is our priority at LoadInn. Read on to understand how
            we handle your information.
          </p>
        </div>
      </section>
      <section>
        <div className="wrapper">
          <div className="privacy_content">
            <p>
              Welcome to LOADINN! Your privacy is very important to us. This
              Privacy Policy outlines the types of personal information we
              collect, how we use it, and the steps we take to protect it. By
              using our services, you agree to the terms of this policy.
            </p>

            <h2>1. Information We Collect</h2>
            <p>
              We collect information to provide better services to all our
              users. The types of information we collect include:
            </p>
            <ul>
              <li>
                <strong>Personal Information:</strong> Your name, email address,
                phone number, and delivery address when you create an account or
                place an order.
              </li>
              <li>
                <strong>Payment Information:</strong> Credit or debit card
                details, payment preferences, and transaction history.
              </li>
              <li>
                <strong>Location Data:</strong> We may collect your precise
                location data to assist with order delivery and tracking.
              </li>
              <li>
                <strong>Order Details:</strong> Information about the items you
                order, special instructions, and delivery notes.
              </li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect in the following ways:</p>
            <ol>
              <li>To process and fulfill your orders.</li>
              <li>
                To communicate with you about your order status, promotions, and
                updates.
              </li>
              <li>
                To improve our services based on your feedback and preferences.
              </li>
              <li>To ensure the security and reliability of our platform.</li>
              <li>To comply with legal obligations and prevent fraud.</li>
            </ol>

            <h2>3. Sharing Your Information</h2>
            <p>
              We do not share your personal information with companies,
              organizations, or individuals outside of LOADINN except in the
              following cases:
            </p>
            <ul>
              <li>
                <strong>With your consent:</strong> We will share personal
                information with companies, organizations, or individuals
                outside of LOADINN when we have your consent to do so.
              </li>
              <li>
                <strong>For external processing:</strong> We provide personal
                information to our trusted partners to process it for us based
                on our instructions and in compliance with our Privacy Policy.
              </li>
              <li>
                <strong>For legal reasons:</strong> We will share personal
                information with third parties if access, use, preservation, or
                disclosure of the information is reasonably necessary to meet
                any applicable law or regulation.
              </li>
            </ul>

            <h2>4. Security of Your Information</h2>
            <p>
              We are committed to protecting your information. We use a variety
              of security technologies and procedures to help protect your
              personal information from unauthorized access, use, or disclosure.
              These measures include:
            </p>
            <ul>
              <li>
                Encryption of sensitive data, such as payment information.
              </li>
              <li>
                Access controls to ensure only authorized personnel can access
                your data.
              </li>
              <li>Regular security audits and assessments of our systems.</li>
            </ul>

            <h2>5. Cookies and Tracking Technologies</h2>
            <p>
              We use cookies and similar tracking technologies to provide,
              customize, and improve our services. You can choose to accept or
              decline cookies through your browser settings, but this may affect
              your ability to use certain features of our website.
            </p>

            <h2>6. Your Choices and Rights</h2>
            <p>
              You have the following rights regarding your personal information:
            </p>
            <ul>
              <li>
                <strong>Access:</strong> You can request a copy of the personal
                information we hold about you.
              </li>
              <li>
                <strong>Correction:</strong> You can ask us to update or correct
                your information if it is inaccurate.
              </li>
              <li>
                <strong>Deletion:</strong> You can request that we delete your
                personal information.
              </li>
              <li>
                <strong>Opt-out:</strong> You can opt out of receiving
                promotional communications from us at any time.
              </li>
            </ul>

            <h2>7. Children's Privacy</h2>
            <p>
              Our services are not directed to children under the age of 13. We
              do not knowingly collect personal information from children under
              13. If we become aware that we have inadvertently collected
              information from a child under 13, we will take steps to delete
              that information as soon as possible.
            </p>

            <h2>8. Changes to This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify
              you of any changes by posting the new Privacy Policy on this page.
              We encourage you to review this Privacy Policy periodically for
              any changes.
            </p>

            <h2>9. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please
              contact us:
            </p>
            <ul>
              <li>
                <strong>Email:</strong>{" "}
                <Link to="mailto:support@loadinn.com">support@loadinn.com</Link>
              </li>
              <li>
                <strong>Phone:</strong>{" "}
                <Link to="tel:+123-456-7890">+123-456-7890</Link>
              </li>
              <li>
                <strong>Address:</strong>{" "}
                <Link
                  to="https://maps.app.goo.gl/kp4wHHaZWcgWEBJT8"
                  target="_blank"
                >
                  1234 Food Street, Cityville, Country
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Privacy;
